import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';

// Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheet/selectors';

const ImportTimesheetEntriesButton = (): React.ReactElement => {
    const dispatch = useDispatch();
    const timesheetId: number | null = useSelector(
        makeSelectTimesheetValue('id')
    );

    const handleClick = () => {
        dispatch(
            updateQueryString({
                importTimesheetEntryModal: true,
                defaultValues: {
                    timesheetId
                }
            })
        );
    };

    return (
        <CurrentSeasonInProgressGate>
            <Button
                circular
                secondary
                size="small"
                onClick={handleClick}
                style={{ marginRight: '5px' }}
            >
                Import
            </Button>
        </CurrentSeasonInProgressGate>
    );
};

export default ImportTimesheetEntriesButton;
